module.exports = __webpack_public_path__ + "img/question_top_right.709b6aea.svg";